import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import TokenManager from './components/shared/TokenManager';
import NavBar from './components/shared/NavBar';
import { NotificationProvider } from './providers/NotificationProvider';
import { ConfigProvider } from 'antd';
import esES from 'antd/lib/locale/es_ES';
import LoadingOverlay from './components/shared/LoadingOverlay';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = {
  token: {
    colorPrimary: '#003270',
    fontFamily: 'Poppins, sans-serif', // Cambiar el tipo de fuente
  },
};
root.render(
  <React.StrictMode>
    <ConfigProvider locale={esES} theme={theme}>
    <Provider store={store}>
    <LoadingOverlay />
    <NotificationProvider>
    <Router>
    <NavBar />
    <TokenManager />
      <App />
    </Router>
    </NotificationProvider>
    </Provider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
